export default __webpack_public_path__ + "static/media/storageChair.2e6d33c7.png";